export const themeAction = () =>({
    type:'setTheme',
})